// @ts-nocheck

import React, { FunctionComponent } from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { isWithinInterval } from 'date-fns'

import { getIsArtist, getArtistBalance } from 'Redux/selectors/auth'
import Arrow from 'mdi-react/ChevronRightIcon'
import CheckIcon from 'mdi-react/CheckIcon'
import logo from 'Shared/img/logo.png'
import logoSmall from 'Shared/img/logoSmall.svg'
import logoXmas from 'Shared/img/logo-xmas.svg'
import logoSmallXmas from 'Shared/img/logo-xmas-mobile.svg'
import { Mobile, Desktop } from 'Shared/components/Responsive'

import TopbarSidebarButton from './TopbarSidebarButton'
import TopbarProfile from './TopbarProfile'
import TopbarNotification from './TopbarNotification'
import TopbarMail from './TopbarMail'
import TopbarBalance from './TopbarBalance'

type TopbarProps = {
  changeMobileSidebarVisibility: () => void
  changeSidebarVisibility: () => void
  sidebar: { hidden: boolean }
  step: number
  isArtist: true
  balance: number
}

const Topbar: FunctionComponent<TopbarProps> = ({
  changeMobileSidebarVisibility,
  changeSidebarVisibility,
  sidebar: { hidden },
  step,
  isArtist,
  balance,
}) => {
  const { t } = useTranslation()

  const isChristmasDate = isWithinInterval(new Date(), {
    start: new Date(2021, 10, 23),
    end: new Date(2022, 0, 8),
  })

  const LogoClass = classNames({
    topbar__logo: true,
    'topbar-with-margin': hidden,
  })

  return (
    <div className="topbar">
      <div className="topbar__wrapper">
        <div className="topbar__left">
          {!hidden && (
            <TopbarSidebarButton
              changeMobileSidebarVisibility={changeMobileSidebarVisibility}
              changeSidebarVisibility={changeSidebarVisibility}
            />
          )}
          <span className={LogoClass}>
            <Link to="/">
              <Desktop>
                <img alt="logo" src={isChristmasDate ? logoXmas : logo} />
              </Desktop>
              <Mobile>
                <img
                  alt="logo"
                  src={isChristmasDate ? logoSmallXmas : logoSmall}
                  style={{ width: '23px' }}
                />
              </Mobile>
            </Link>
          </span>
        </div>
        {!hidden ? (
          <div className="topbar__right">
            {isArtist && balance ? <TopbarBalance balance={balance} /> : null}
            <TopbarMail new />
            <TopbarNotification />
            <TopbarProfile />
          </div>
        ) : (
          <div className="checkout__steps">
            <div className={`${step >= 1 && 'step-active'} step`}>
              <div className="count">{step > 1 ? <CheckIcon /> : 1}</div>
              <p>{t('topbar.campaignDetails')}</p>
              <Arrow />
            </div>
            <div className={`${step >= 2 && 'step-active'} step`}>
              <div className="count">{step > 2 ? <CheckIcon /> : 2}</div>
              <p>{t('topbar.confirm')}</p>
              <Arrow />
            </div>
            <div className={`${step === 3 && 'step-active'} step`}>
              <div className="count">{step === 3 ? <CheckIcon /> : 3}</div>
              <p>{t('topbar.launch')}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const selector = createStructuredSelector({
  isArtist: getIsArtist,
  balance: getArtistBalance,
})

//  eslint-disable-next-line @typescript-eslint/no-explicit-any
export default compose<any>(connect(selector))(Topbar)
